<template>
  <div v-if="visible" class="confim-cmp">
    <div class="content-box">
      <img src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/iconfontxiaogantanhao.png" alt="" srcset="">
      <div>{{message}}</div>
      <div class="btn-box">
        <Btn
          :btnText="confirmButtonText"
          className="primary_plain"
          :fontSize="14"
          :width="78"
          :height="35"
          @handleClick="handler('confirm')"
        />
        <Btn
          :btnText="cancelButtonText"
          className="primary"
          :fontSize="14"
          :width="78"
          :height="35"
          @handleClick="handler('cancel')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Btn from './Btn.vue'
export default {
  components: { Btn },
  props: {
    message: {
      type: String,
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    confirm: {
      type: Function,
      default: new Function()
    },
    cancel: {
      type: Function
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    handler(type) {
      this.visible = false
      this[type] && this[type]()
    }
  }
}
</script>

<style lang="scss" scoped>
.confim-cmp{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.45);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .content-box{
    width: 383px;
    background: #fff;
    border-radius: 16px;
    padding: 39px 47px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8D8D8D;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    img{
      width: 53px;
      height: 53px;
      margin-bottom: 25px;
    }
    .btn-box{
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 186px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ConfirmCmp.vue